import { Head } from '@inertiajs/react'
import type { ReactNode } from 'react'
import Layout from '@/layouts/Layout'

export default function Privacy() {
  return (
    <>
      <Head title="Privacy Policy" />
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

        <div className="prose">
          <p className="mb-4">
            At three.pm, we take your privacy seriously. This policy describes how we collect, use,
            and protect your personal information.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">Information We Collect</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>Phone number (for SMS-based authentication)</li>
            <li>Username and profile information you provide</li>
            <li>Photos you upload to share</li>
            <li>Location data (if you choose to share it)</li>
            <li>Usage information and analytics</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">How We Use Your Information</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>To provide and improve our service</li>
            <li>To send you daily reminders and notifications</li>
            <li>To share your content with your followers</li>
            <li>To respond to your requests and support needs</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">Data Storage and Security</h2>
          <p className="mb-4">
            Your data is stored securely using industry-standard encryption. Photos are stored on
            Amazon S3 with secure access controls.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">Sharing with Third Parties</h2>
          <p className="mb-4">
            We do not sell your personal information. We may share data with service providers who
            help us operate our service (hosting, SMS delivery, etc.).
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">Your Rights</h2>
          <p className="mb-4">
            You can request access to, correction of, or deletion of your personal data at any time
            by contacting us.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">Contact Us</h2>
          <p className="mb-4">
            If you have questions about this privacy policy, please message us through the service.
          </p>
        </div>
      </div>
    </>
  )
}

Privacy.layout = (page: ReactNode) => <Layout>{page}</Layout>
